const WHATSAPP_LINK = 'https://wa.me/573057096663?text=Hola%2C%20%C2%BFEn%20qu%C3%A9%20podemos%20ayudarte%3F';

export default function Contact() {
  return (
    <section id="contacto" className="bg-[#111111] py-24 relative overflow-hidden">
      {/* Background glow */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_rgba(37,99,235,0.08)_0%,_transparent_70%)]"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6">
        {/* Main CTA */}
        <div className="text-center mb-16">
          <div className="w-16 h-16 md:w-20 md:h-20 flex items-center justify-center bg-[#2563eb]/15 rounded-full mx-auto mb-6 animate-pulse">
            <i className="ri-whatsapp-line text-3xl md:text-4xl text-[#2563eb]"></i>
          </div>
          <h2 className="text-2xl md:text-5xl font-extrabold text-white mb-4">
            ¿Listo para Encontrar<br />
            <span className="text-[#2563eb]">tu Repuesto?</span>
          </h2>
          <p className="text-gray-400 text-sm md:text-lg max-w-xl mx-auto mb-6 md:mb-8">
            Cotiza ahora y recibe atención personalizada de nuestros especialistas mecánicos. Respuesta inmediata por WhatsApp.
          </p>
          <a
            href={WHATSAPP_LINK}
            target="_blank"
            rel="nofollow noreferrer"
            className="inline-flex items-center gap-2 md:gap-3 bg-[#2563eb] hover:bg-[#1d4ed8] text-white font-bold px-7 md:px-10 py-3.5 md:py-5 rounded-full text-base md:text-lg transition-all duration-200 whitespace-nowrap cursor-pointer shadow-xl shadow-blue-900/30"
          >
            <i className="ri-whatsapp-line text-xl md:text-2xl"></i>
            Abrir WhatsApp Ahora
            <i className="ri-arrow-right-line text-lg md:text-xl"></i>
          </a>
        </div>

        {/* Info Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
          {[
            {
              icon: 'ri-map-pin-line',
              title: 'Ubicación',
              lines: ['Bogotá, Colombia', 'Sector 7 de Agosto'],
              color: 'text-[#2563eb]',
              bg: 'bg-[#2563eb]/10',
            },
            {
              icon: 'ri-time-line',
              title: 'Horario de Atención',
              lines: ['Lunes a Sábado', '8:00 AM – 6:00 PM'],
              color: 'text-blue-400',
              bg: 'bg-blue-500/10',
            },
            {
              icon: 'ri-whatsapp-line',
              title: 'WhatsApp',
              lines: ['+57 305 7096663', 'Respuesta inmediata'],
              color: 'text-orange-400',
              bg: 'bg-orange-500/10',
            },
          ].map((info) => (
            <div key={info.title} className="bg-[#1a1a1a] border border-gray-800 rounded-xl p-6 text-center">
              <div className={`w-12 h-12 flex items-center justify-center ${info.bg} rounded-xl mx-auto mb-4`}>
                <i className={`${info.icon} text-2xl ${info.color}`}></i>
              </div>
              <h3 className="text-white font-bold text-base mb-2">{info.title}</h3>
              {info.lines.map((line) => (
                <p key={line} className="text-gray-400 text-sm">{line}</p>
              ))}
            </div>
          ))}
        </div>

        {/* Map */}
        <div className="rounded-xl overflow-hidden border border-gray-800 h-64 md:h-80">
          <iframe
            title="Ubicación Chevrokee Automotriz - Bogotá 7 de Agosto"
            src="https://maps.google.com/maps?q=Chevrokee+Automotriz+7+de+Agosto+Bogota+Colombia&output=embed&hl=es"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
        <div className="text-center mt-4">
          <a
            href="https://maps.app.goo.gl/3pGhgt1Aa2QQ6GS78"
            target="_blank"
            rel="nofollow noreferrer"
            className="inline-flex items-center gap-2 border border-gray-700 hover:border-[#2563eb] text-gray-400 hover:text-[#2563eb] text-sm font-medium px-5 py-2.5 rounded-full transition-all duration-200 cursor-pointer"
          >
            <i className="ri-map-pin-line"></i>
            Ver ubicación exacta en Google Maps
            <i className="ri-external-link-line text-xs"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
